import { AxiosRequestConfig } from 'axios';

export default {
    getExchangeRates: (currency = 'ETH') =>
        ({
            method: 'GET',
            url: `https://api.coinbase.com/v2/exchange-rates?currency=${currency}`,
        } as AxiosRequestConfig),
};
